import { Header, Footer, PageHero, EstimateForm, LocationBlock } from "@/components/site";

export default function ContactPage() {
  return (
    <div className="bg-white text-slate-800">
      <Header />
      <PageHero overline="Get In Touch" title="Contact Us for a Free Estimate" subtitle="Call, text, or send us a message — fast response, free estimates, and no obligation." />
      <EstimateForm />
      <LocationBlock />
      <Footer />
    </div>
  );
}
